/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestPlansIfNotRequested } from 'state/web-plans/actions';
import { getAllWebPlans, requestingWebPlans } from 'state/web-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { getCurrentWebId, getCurrentWebPlanId, getCurrentWeb } from 'state/current-web/selectors';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { requestCurrentWeb } from 'state/current-web/actions';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import page from 'page';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectWebPlan = (props) => {
    const webPlans = props.webPlans;
    const [submitting, setSubmitting] = useState(false);

    const onChange = (value) => {
        if (!props.websubscriptionId) {
            return newPlanSubscription(value);
        }

        let plan = find(webPlans, { id: value });
        let addon = resolveLicenseAddon(plan);

        confirmAlert({
            title: 'Change Shopify Development Plan',
            message: 'Are you sure to do this. Changes will take affect next billing period.',
            submitting,
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ConfirmNewPlanAlert
                    currentWeb={props.currentWeb}
                    subscriptionId={props.websubscriptionId}
                    newPlanId={plan.id}
                    plan={plan}
                    onClose={onClose}
                    onSubmit={() => handleSubmit(value)}
                />
            ),
        });
    };

    useEffect(() => {
        props.requestWebPlans();
        props.requestAddons();
        props.requestCoupons();
    }, []);

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.websubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Shopify development subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const newPlanSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newPlanSubscription(planId),
            error: (e) => console.log(e),
            // close: () => { window.location.reload(); },
            success: () => {
                props.requestCurrentWeb();
                props.successNotice('Your Shopify development subscription has been created.');
                page.redirect('/dashboard/shopify-development');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {

        return null;
    };

    if (props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {webPlans.map((plan, i) => {
                        return (
                            <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentWeb && props.currentWeb.status == 'cancelled')
                                        ? plan.id == props.webPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        webPlans: getAllWebPlans(state),
        addons: getAllAddons(state),
        websubscriptionId: getCurrentWebId(state),
        webPlanId: getCurrentWebPlanId(state),
        currentWeb: getCurrentWeb(state),
        currentUser: getCurrentUser(state),
        requesting: requestingWebPlans(state),
    }),
    {
        requestWebPlans: requestPlansIfNotRequested,
        requestCurrentWeb,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
    },
)(SelectWebPlan);
